<template>
  <div class="experts">
    <div
      v-for="expert in experts"
      :key="expert.title"
      class="expert-card"
      :style="getCssVariables(!!expert.text)"
    >
      <div class="expert-card__header">
        <div
          v-if="expert.image_url"
          class="expert-card__image"
        >
          <img
            :src="expert.image_url"
            alt="Фото эксперта"
          />
        </div>
        <div class="expert-card__header-right">
          <a
            :href="expert.link"
            class="expert-card__expert-name"
            >{{ expert.title }}</a
          >
          <p class="expert-card__expert-expertise">
            {{ expert.description }}
          </p>
        </div>
      </div>
      <p
        v-if="expert.text"
        class="expert-card__about"
      >
        {{ expert.text }}
      </p>
    </div>
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';

  interface HealthExpert {
    title: string;
    description: string;
    text?: string;
    image_url: string;
    link: string;
  }

  interface HealthExpertCard {
    items: HealthExpert[];
  }

  export default defineNuxtComponent({
    name: 'HealthExperts',

    props: {
      elem: {
        type: Object as PropType<TContent<HealthExpertCard>>,
        required: true,
      },
    },

    computed: {
      experts(): HealthExpert[] {
        return this.elem.attributes.items;
      },
    },

    methods: {
      getCssVariables(hasAbout: boolean): Record<string, string> {
        return {
          '--expertise-color': hasAbout ? '5c5c5c' : '#000',
          '--expertise-fz-mobile': hasAbout ? '12px' : '14px',
          '--expertise-fz': hasAbout ? '12px' : '16px',
        };
      },
    },
  });
</script>

<style lang="scss" scoped>
  .experts {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 12px;
    margin-top: 24px;
  }

  .expert-card {
    padding: 16px;
    position: relative;
    background-color: #f3f5fc;
    width: 100%;

    @include big-tablet {
      width: calc(50% - 6px);
    }

    @include tablet {
      padding: 24px;
    }
    @include hover {
      &__expert-name {
        border-bottom: 1px solid #000;
      }
    }

    &__header {
      @include tablet {
        display: flex;
        align-items: center;
      }
      @include big-tablet {
        display: block;
      }
    }
    &__header-right {
      @include tablet {
        margin-left: 16px;
      }
      @include big-tablet {
        margin-left: 0;
      }
    }

    &__image {
      height: 85px;
      min-width: 85px;
      max-width: 85px;
      border-radius: 50%;
      margin-bottom: 8px;
      overflow: hidden;
    }

    &__expert-name {
      font-weight: 600;
      font-size: 18px;
      line-height: 26px;
      color: #000;
      font-family: $secondFont;
      text-decoration: none;
      @include tablet {
        font-size: 20px;
        line-height: 28px;
      }
      @include hover {
        border-bottom: 2px solid #000;
      }
    }

    &__expert-expertise {
      font-size: var(--expertise-fz-mobile);
      line-height: 18px;
      font-weight: 400;
      color: var(--expertise-color);
      font-family: $mainFont;
      margin-top: 4px;
      @include tablet {
        font-size: var(--expertise-fz);
      }
    }

    &__about {
      font-size: 14px;
      line-height: 20px;
      font-weight: 400;
      font-family: $mainFont;
      color: #000;
      margin-top: 16px;
      @include tablet {
        font-size: 16px;
        line-height: 24px;
      }
    }
  }
</style>
